/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{6AE7ADFC-741D-43B5-BE48-C87A6F662CBF}",
  "sitecoreApiHost": "https://www.osim.co.th",
  "jssAppName": "osim-web-shop-th",
  "defaultLanguage": "th-TH",
  "graphQLEndpointPath": "/api/osim-web-shop",
  "buildTime": "Mon May 26 2025 19:18:53 GMT+0700 (Indochina Time)",
  "gitVersion": "11a3e5bb84e2bf68f933582e5c9d49a1217fbf4b",
  "graphQLEndpoint": "https://www.osim.co.th/api/osim-web-shop?sc_apikey={6AE7ADFC-741D-43B5-BE48-C87A6F662CBF}"
};